import { render, staticRenderFns } from "./newWikiViewer.vue?vue&type=template&id=132f9704&scoped=true&"
import script from "./newWikiViewer.vue?vue&type=script&lang=js&"
export * from "./newWikiViewer.vue?vue&type=script&lang=js&"
import style0 from "./newWikiViewer.vue?vue&type=style&index=0&id=132f9704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f9704",
  null
  
)

export default component.exports